import { HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';
import { FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';

const CONTACTS = [
  {
    href: 'mailto:muriithijoanchristine@gmail.com',
    icon: HiOutlineMail,
    label: 'Email',
    value: 'muriithijoanchristine@gmail.com',
  },
  {
    href: 'tel:0702405954',
    icon: HiOutlinePhone,
    label: 'Phone',
    value: '0702405954',
  },
  {
    href: 'tel:0795837734',
    icon: HiOutlinePhone,
    label: 'Phone',
    value: '0795837734',
  },
  {
    href: 'https://wa.me/254702405954?text=Hello%20Jowey%2C%20the%20website%20sent%20me%20here%F0%9F%98%8A',
    icon: FaWhatsapp,
    label: 'WhatsApp',
    value: 'Message on WhatsApp',
    external: true,
  },
];

export default function Contact() {
  return (
    <div className="page container">
      <SEO
        title="Contact Jowey's | Joan Christine Nyawira"
        description="Get in touch with Joan Christine Nyawira for physiotherapy, digital marketing, writing collaborations, or custom orders — by email, phone, or WhatsApp."
        path="/contact"
      />
      <div className="glass-card" style={{ maxWidth: 720, margin: '0 auto' }}>
        <h1>Contact Me</h1>
        <p>
          Have a question, a custom order, or a collaboration in mind? Reach out through
          any of the channels below.
        </p>
        <div className="contact-grid">
          {CONTACTS.map(({ href, icon: Icon, label, value, external }) => (
            <a
              key={href}
              href={href}
              className="contact-item"
              {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}
            >
              <Icon className="contact-icon" />
              <span className="contact-label">{label}</span>
              <span className="contact-value">{value}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
